export const categories = [
  { id: "magic", name: "魔法漫画", slug: "magic", icon: "ri-magic-line", description: "汇聚顶尖魔法题材漫画，从元素操控到时空魔法，带你进入神秘的法术世界。", color: "accent" },
  { id: "fantasy", name: "奇幻漫画", slug: "fantasy", icon: "ri-compass-3-line", description: "探索异世界大陆，与勇者、精灵、巨龙同行，开启恢弘的奇幻冒险史诗。", color: "primary" },
  { id: "superpower", name: "异能漫画", slug: "superpower", icon: "ri-flashlight-line", description: "都市中的超能力者，隐身、读心、念动力，平凡外表下隐藏着不平凡的力量。", color: "secondary" },
  { id: "adventure", name: "冒险漫画", slug: "adventure", icon: "ri-sword-line", description: "热血冒险旅程，未知遗迹、神秘宝藏、强大敌人，见证主角一步步成长。", color: "accent" },
  { id: "xuanhuan", name: "玄幻漫画", slug: "xuanhuan", icon: "ri-star-smile-line", description: "东方玄幻世界，修仙炼气、渡劫飞升，领略浩瀚仙侠宇宙的无穷魅力。", color: "primary" },
  { id: "urban", name: "都市异能", slug: "urban", icon: "ri-building-2-line", description: "现代都市背景下的超自然故事，隐藏在钢筋水泥间的魔法与异能对决。", color: "secondary" },
];

export const categoryColorMap: Record<string, string> = {
  magic: "accent",
  fantasy: "primary",
  superpower: "secondary",
  adventure: "accent",
  xuanhuan: "primary",
  urban: "secondary",
};